export const ENABLE_MASTER_INITIAL_SETUP = true;
